<template>
    <Modal idModal="ModalImportBoq" :headerTitle="$t('Import')" modalSize="modal-md">
        <div class="hle-import-modal">
            <div class="form-group hle-import-modal__field" >
                <label class="required-style">
                    {{$t('File')}}
                </label>
                <input type="file" class="form-control hle-import-modal__input" ref="uploadFile" :disabled="isImportRunning" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                <small class="text-warning" v-if="!newBoqImport.file&&isImportClicked">Required <br /></small>
            </div>
            <div class="form-group hle-import-modal__field" v-if="projectId">
                <div class="hle-import-modal__label-row">
                    <label class="required-style">{{ $t('Template') }} </label>
                    <a href="#" class="small hle-import-modal__download" role="button" @click="DownloadTemplate"><i class="fa-solid fa-download"></i> {{$t('Download selected template')}}</a>
                </div>
                <select class="form-select hle-import-modal__input" v-model="newBoqImport.templateType" :disabled="isImportRunning">
                    <option value="">{{$t('Please Select')}}</option>
                    <option v-for="(item,key) in ExportTemplates" :key="key" :value="key">{{item}}</option>
                </select>
                <small v-if="newBoqImport.templateType !== '' && newBoqImport.templateType !== undefined" class="text-muted d-block mt-1">
                    {{ supportsEmbeddedImageImport
                        ? $t('Embedded images must be placed on the line item row in the Template sheet. Maximum 3 images per item, up to 2 MB each.')
                        : $t('Embedded images are supported only with the System Template.') }}
                </small>
                <small class="text-warning" v-if="newBoqImport.templateType===''&&isImportClicked">{{ $t('Required') }}</small>
            </div>
            <!-- <div class="form-group">
                <label > Rate Template </label>
                <select class="form-select text-capitalize" v-model="newBoqImport.templateRate">
                    <option value="">Please Select</option>
                    <option v-for="(item,key) in rateTemplates" :key="key" :value="item._id" >{{item.name}}</option>
                </select>
            </div> -->
            
            <div v-if="typeof boqId ==='undefined'">
                <div class="form-group">
                    <label >Existing BoQ? </label>
                    <select class="form-select" v-model="newBoqImport.existing" @change="ChangeType">
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                    </select>
                </div>
                <div v-if="newBoqImport.existing=='false'">
                    <div class="form-group">
                        <label class="required-style">Bill of Quantities Name </label>
                        <input type="text" class="form-control" v-model="newBoqImport.name" placeholder="BoQ Name" />
                        <small class="text-warning" v-if="!newBoqImport.name&&isImportClicked">{{ $t('Required') }}</small>
                    </div>
                    <div class="form-group">
                        <label class="required-style">Reference </label>
                        <Select2
                        :filterQuery="()=>{}"
                        indexValue="_id"
                        labelName="fullname"
                        placeHolder="Search Quotation here"
                        v-model:optionValue="newBoqImport.reference"
                        ref="selectQuotationList"
                        :dataOptions="quotationList"
                        :willCapitalize="false"
                        />
                        <small class="text-warning" v-if="!newBoqImport.reference&&isImportClicked">{{ $t('Required') }}</small>
                    </div>
                </div>
                <div v-else>
                    <div class="form-group">
                        <label class="required-style">Search BOQ </label>
                        <Select2
                        :filterQuery="GetBoqsProjects"
                        indexValue="_id"
                        labelName="name"
                        placeHolder="Search Boq here"
                        :dataOptions="boqList"
                        v-model:optionValue="newBoqImport.boqId"
                        ref="selectBoqList"
                        >
                        </Select2>
                        <small class="text-warning" v-if="!newBoqImport.boqId&&isImportClicked">{{ $t('Required') }}</small>
                    </div>
                
                </div>
            </div>
            <div v-if="isImportRunning" class="hle-import-modal__loading" role="status" aria-live="polite">
                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                <span>{{ isPreparingUpload ? $t('Optimizing workbook images') : $t('Import loading message') }}</span>
            </div>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeModalImportBoq" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" :disabled="isImportRunning" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="isImportRunning" @click="UploadTemplate1">
                <span v-if="isImportRunning" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                <i v-else-if="!isDeluxeLayout" class="fa-solid fa-save"></i>
                {{ isImportRunning ? $t('Importing file') : $t('Import') }}
            </button>
        </template>
        </Modal>
</template>

<script>
import Modal from '@/components/layout/Modal.vue'
import Select2 from '@/components/layout/Select2.vue'
import { UploadTemplate1ToMasterList, SearchBoqFromProject, DownloadTemplate1, ExportCostXTemplate, ExportFiveDTemplate } from '@/actions/boqActions.js'
import {mapGetters} from 'vuex'
import {ExportTemplates} from '@/helpers/utilities.js'
import {OptimizeBoqWorkbookImages} from '@/helpers/boqWorkbookImageCompression.js'
import {measurementUnits} from '@/assets/dataJson/commercial_management.json'
export default {
    name : 'ModalUpdateLineItem',
    components : {
        Modal, Select2
    },
    props : ['ResetData','boqList', 'boqId','projectId','quotationList','parentId'],
    methods :{
        ImportUploadErrorMessage(error){
            if(error?.response?.status === 413){
                return this.$i18n.t('Workbook upload rejected message')
            }
            if(!error?.response && (error?.isAxiosError || error?.request
                || ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(error?.code)
                || error?.message === 'Network Error')){
                return this.$i18n.t('Workbook upload connection message')
            }
            const response = error?.response?.data
            if(typeof response?.message === 'string') return response.message
            if(typeof response === 'string' && response.trim()
                && !/<(?:!doctype|html|head|body)\b/i.test(response)) return response
            if(error?.response) return this.$i18n.t('Import failure message')
            return error?.message || this.$i18n.t('Import failure message')
        },
        EscapeImportSummaryHtml(value){
            return String(value ?? '')
                .replaceAll('&','&amp;')
                .replaceAll('<','&lt;')
                .replaceAll('>','&gt;')
                .replaceAll('"','&quot;')
                .replaceAll("'",'&#039;')
        },
        async ShowImportSummary(summary){
            const readCount = value => {
                if(!['number','string'].includes(typeof value) || String(value).trim()==='') return null
                const count = Number(value)
                return Number.isSafeInteger(count) && count>=0 ? count : null
            }
            const imported = readCount(summary?.imported)
            const updated = readCount(summary?.updated)
            const successful = imported!==null && updated!==null
                ? imported + updated
                : readCount(summary?.successful)
            const skipped = readCount(summary?.skipped)
            const blocked = summary?.blocked===true || summary?.validationFailed===true
            const skippedRows = Array.isArray(summary?.skippedRows) ? summary.skippedRows : []
            const imageWarnings = Array.isArray(summary?.imageWarnings) ? summary.imageWarnings : []
            const skippedDetails = skippedRows.map(item=>{
                const sheet = String(item.sheet || '').trim()
                const sheetPrefix = sheet && sheet.toLowerCase()!=='template' ? `${sheet} ` : ''
                const location = `${sheetPrefix}${this.$i18n.t('Row')} ${item.row}`
                const costCode = item.costCode ? ` (${item.costCode})` : ''
                const reason = String(item.reason || '')
                return `<li><strong>${this.EscapeImportSummaryHtml(location + costCode)}</strong>: ${this.EscapeImportSummaryHtml(reason)}</li>`
            }).join('')
            const details = skippedDetails
                ? `<div class="boq-import-summary__details">
                    <strong>${this.EscapeImportSummaryHtml(this.$i18n.t('Skipped row details'))}</strong>
                    <ol style="margin:.5rem 0 0;padding-left:1.4rem;">${skippedDetails}</ol>
                </div>`
                : ''
            const imageWarningDetails = imageWarnings.map(item=>{
                const sheet = String(item.sheet || '').trim()
                const sheetPrefix = sheet && sheet.toLowerCase()!=='template' ? `${sheet} ` : ''
                const location = `${sheetPrefix}${this.$i18n.t('Row')} ${item.row}`
                return `<li><strong>${this.EscapeImportSummaryHtml(location)}</strong>: ${this.EscapeImportSummaryHtml(item.reason || '')}</li>`
            }).join('')
            const imageDetails = imageWarningDetails
                ? `<div class="boq-import-summary__details boq-import-summary__details--images">
                    <strong>${this.EscapeImportSummaryHtml(this.$i18n.t('Images not attached'))}</strong>
                    <ol style="margin:.5rem 0 0;padding-left:1.4rem;">${imageWarningDetails}</ol>
                </div>`
                : ''
            const countLine = (label,count) => count===null ? ''
                : `<p style="margin-bottom:.25rem;"><strong>${this.EscapeImportSummaryHtml(this.$i18n.t(label))}:</strong> ${count}</p>`
            const overview = blocked
                ? this.$i18n.t('Import blocked message')
                : successful!==null && skipped!==null
                    ? this.$i18n.t('Import saved summary message',{successful,skipped})
                    : this.$i18n.t('Import counts unavailable')
            const imagesImported = readCount(summary?.imagesImported)

            return await this.$swal({
                title : blocked
                    ? this.$i18n.t('Import blocked')
                    : imageWarnings.length
                        ? this.$i18n.t('Import completed with image warnings')
                    : successful===null || skipped===null
                        ? this.$i18n.t('Import counts unavailable title')
                        : successful===0
                            ? this.$i18n.t('No rows imported')
                            : skipped>0
                                ? this.$i18n.t('Import completed with skipped rows')
                                : this.$i18n.t('Import completed'),
                icon : blocked || imageWarnings.length>0 || successful===null || successful===0 || skipped===null || skipped>0 ? 'warning' : 'success',
                html : `<div class="boq-import-summary__layout">
                    <div class="boq-import-summary__overview">
                        <p>${this.EscapeImportSummaryHtml(overview)}</p>
                        ${countLine('Saved rows',successful)}
                        ${countLine('Imported rows',imported)}
                        ${countLine('Updated rows',updated)}
                        ${countLine('Skipped rows',skipped)}
                        ${imagesImported===null ? '' : countLine('Images attached',imagesImported)}
                        <small>${this.EscapeImportSummaryHtml(this.$i18n.t('Import does not create cost codes'))}</small>
                    </div>
                    ${details}
                    ${imageDetails}
                </div>`,
                width : 'min(58rem, 96vw)',
                customClass : {
                    container : 'lens-feedback-alert__container',
                    popup : 'lens-feedback-alert',
                    icon : 'lens-feedback-alert__icon',
                    title : 'lens-feedback-alert__title',
                    htmlContainer : 'lens-feedback-alert__content boq-import-summary__html',
                    actions : 'lens-feedback-alert__actions',
                    confirmButton : 'lens-feedback-alert__confirm',
                    cancelButton : 'lens-feedback-alert__cancel',
                    denyButton : 'lens-feedback-alert__deny',
                    closeButton : 'lens-feedback-alert__close'
                }
            })
        },
        async UploadTemplate1(){
            let data = new FormData()
            const self = this

            if(self.isImportRunning){
                return
            }
            const file = self.$refs.uploadFile.files[0]
            const newData = self.newBoqImport
            self.isImportClicked = true
            newData.file = ''
            if(!file ){
                return
            }
            newData.file = 'new file'

            if(newData.templateType===''){
                return
            }


            data.append('id',self.projectInfo._id)
            data.append('templateType',newData.templateType)
            data.append('templateRate',newData.templateRate)
            if(self.parentId){
                data.append('sequenceParentId',self.parentId)
            }

            if(self.boqId){

                data.append('boqId',self.boqId)
            }else{
                if(newData.existing=='true'){
                    if(!newData.boqId){
                        return
                    }
                    
                    data.append('boqId',newData.boqId)
                }else{
                    if(!newData.name || !newData.reference){
                        return
                    }
                    data.append('name',newData.name)
                    data.append('reference',newData.reference)
                }
            }
            self.isImportRunning = true
            self.isImportClicked = false
            let uploadFile = file
            if(String(newData.templateType) === '0'){
                self.isPreparingUpload = true
                try{
                    uploadFile = await OptimizeBoqWorkbookImages(file)
                }catch(error){
                    self.isPreparingUpload = false
                    self.isImportRunning = false
                    await self.$swal(
                        self.$i18n.t('Import File'),
                        error?.message || self.$i18n.t('Workbook image optimization failed'),
                        'warning'
                    )
                    return
                }
                self.isPreparingUpload = false
            }
            // Nginx counts the complete multipart request, including form fields.
            const maxFileBytes = 25 * 1024 * 1024 - 64 * 1024
            if(uploadFile.size > maxFileBytes){
                self.isImportRunning = false
                await self.$swal(
                    self.$i18n.t('Workbook upload too large title'),
                    self.$i18n.t('Workbook upload too large message', {size: (uploadFile.size / (1024 * 1024)).toFixed(2)}),
                    'warning'
                )
                return
            }
            data.append('template1', uploadFile)
            if(newData.templateType===0 || newData.templateType===1|| newData.templateType===2){
                let importConfirmed = false
                try{
                    const res = await UploadTemplate1ToMasterList(data)
                    self.isImportRunning = false
                    const blocked = res?.blocked===true || res?.validationFailed===true
                        || res?.summary?.blocked===true || res?.summary?.validationFailed===true
                    if(blocked){
                        await self.ShowImportSummary({...res?.summary,blocked:true})
                    }
                    else if(res=='OK' || res===true || res?.success===true){
                        importConfirmed = true
                        await self.ResetData()
                        self.$refs.closeModalImportBoq.click()
                        if(res?.summary){
                            await self.ShowImportSummary(res.summary)
                        }else{
                            await self.$swal(
                                self.$i18n.t('Import File'),
                                self.$i18n.t('Import success message'),
                                'success'
                            )
                        }
                        // Refresh after the success message closes, whether the user
                        // clicks Proceed or the top-right close button.
                        window.location.reload()
                    }
                    else{
                        await self.$swal(
                            self.$i18n.t('Import File'),
                            res?.message || (typeof res==='string' ? res : '') || self.$i18n.t('Import failure message'),
                            'warning'
                        )
                    }
                }
                catch(err){
                    self.isImportRunning = false
                    await self.$swal(
                        self.$i18n.t(!importConfirmed && err?.response?.status === 413 ? 'Workbook upload too large title' : 'Import File'),
                        importConfirmed
                            ? self.$i18n.t('Import saved but refresh failed')
                            : self.ImportUploadErrorMessage(err),
                        'warning'
                    )
                }
            }else{
                self.isImportRunning = false
                await this.$swal('Import Template','Sorry not yet implemented','warning')
            }
            
        },
        GetBoqsProjects(search){
            return SearchBoqFromProject({search : search, id : this.projectInfo._id})
        },
        ClearData(){
            this.$refs.uploadFile.value = '',
            this.newBoqImport =  {
                templateType : '', 
                existing : 'true',
                boqId : '',
                templateRate : ''
            }
        },
        DownloadTemplate(){
            if(this.newBoqImport.templateType===''){
                this.$swal({
                    icon : 'warning',
                    title : this.$i18n.t('Template Selection Required'),
                    text : this.$i18n.t('Please select a template from the list before downloading.'),
                    confirmButtonText : this.$i18n.t('OK')
                })
                return
            }

            if(this.newBoqImport.templateType===0)
                DownloadTemplate1()
            else if(this.newBoqImport.templateType===1)
                ExportFiveDTemplate()
            else if(this.newBoqImport.templateType===2)
                ExportCostXTemplate()
            else
                this.$swal({
                    icon : 'warning',
                    title : this.$i18n.t('Template Unavailable'),
                    text : this.$i18n.t('The selected template is currently unavailable. Please select a different template.'),
                    confirmButtonText : this.$i18n.t('OK')
                })
        }
    },
    mounted : async function(){
        // this.rateTemplates = await GetBoqRateTemplates({id : this.projectId, isSelect : 1})
    },
    computed :{
        ...mapGetters(['projectInfo']),
        isDeluxeLayout(){
            return this.$route.meta.layout == 'deluxe'
        },
        supportsEmbeddedImageImport(){
            return String(this.newBoqImport.templateType) === '0'
        },
    },
    data (){ 
        return {
            newBoqImport :  {},
            isImportClicked : false,
            measurementUnits : measurementUnits,
            rateTemplates : [],
            isPreparingUpload : false,
            ExportTemplates : ExportTemplates,
            isImportRunning : false,
        }
    }
}
</script>

<style scoped>
.hle-import-modal__loading {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    margin-top: 0.1rem;
    border: 1px solid rgba(202, 80, 21, 0.28);
    border-radius: 0.25rem;
    padding: 0.8rem 0.9rem;
    background: #fff6ef;
    color: #6f3215;
    font-size: 0.82rem;
    font-weight: 700;
    line-height: 1.4;
}

.hle-import-modal__loading .spinner-border {
    flex: 0 0 auto;
    width: 1rem;
    height: 1rem;
    color: var(--lens-accent, #ca5015);
}
</style>

<style>
.lens-feedback-alert.swal2-popup .lens-feedback-alert__content.swal2-html-container.boq-import-summary__html {
    width: calc(100% - 3.2em);
    max-width: none;
    margin: 0.95rem 1.6em 0;
    overflow: visible;
}

.boq-import-summary__layout {
    display: grid;
    grid-template-columns: minmax(18rem, 0.8fr) minmax(30rem, 1.7fr);
    gap: 1.5rem;
    align-items: start;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
}

.boq-import-summary__overview {
    padding: 0.75rem 0;
}

.boq-import-summary__details {
    max-height: 34rem;
    overflow: auto;
    padding: 0.85rem 1rem;
    border: 1px solid #ead8cd;
    border-radius: 0.25rem;
    background: #fffaf7;
}

@media (max-width: 850px) {
    .boq-import-summary__layout {
        grid-template-columns: 1fr;
    }

    .boq-import-summary__details {
        max-height: 22rem;
    }
}
</style>
